(function () {
    'use strict';

    angular
        .module('app')
        .factory('searchCardService', searchCardService);

    searchCardService.$inject = ['$http', '$q', '$filter', '$httpParamSerializer', 'loginService'];

    function searchCardService($http, $q, $filter, $httpParamSerializer, loginService) {
        var service = {
            getCurrent: getCurrent,
            setCurrent: setCurrent,
            getRestrictedValues: getRestrictedValues,
            availableDataCards: [],
            loading: false,
            currentDataCardId: "",
            currentDataCard: {},
            schemaDefinitions: {},
            tabs: [],
            schemaModels: {},
            singleCard: false,
            dataCardDropdownTitle: "",
            searchCriteria: []
        };

        return service;

        function getCurrent() {
            var deferred = $q.defer();
            service.loading = true;

            //label and input positioning
            vm.yFactor = 30;
            vm.yOffset = 12;

            vm.yOffsetPrompts = 18;
            vm.textBoxHeight = 30;
            vm.restrictedBoxHeight = 200;

            //Call to the server to get the current data card.
            $http.get('../Synergis.WebApi/api/DataCard/DataCardStructure/').then(function (response) {
                service.availableDataCards = response.data.availableDataCards;

                // If only 1 card, we'll disable the dropdown and change the dropdown prompt.
                service.singleCard = Object.keys(service.availableDataCards).length < 2;
                service.dataCardDropdownTitle = loginService.resourceStrings["AVAILABLE_DATA_CARDS"] + ":"; // "Available Data Cards:";
                if (service.singleCard)
                    service.dataCardDropdownTitle = loginService.resourceStrings["DATA_CARD"] + ":"; // "Data Card:";

                service.currentDataCard = response.data.currentDataCard;
                service.currentDataCardId = response.data.currentDataCardId;
                service.showMemo = response.data.currentDataCard.dataCardDefinition.bHasMemo;
                service.showThumbNail = response.data.currentDataCard.dataCardDefinition.bHasPreview;

                // enums and defines (To avoid inline constants and prevent enum re-order problems.)
                service.const_FieldTypePrompt = response.data.const_FieldTypePrompt;          // ApiTypes.ADEPT_FIELD_TYPE.F_PROMPT
                service.const_FldDefTypeDateOnly = response.data.const_FldDefTypeDateOnly;    // ApiTypes.ADEPTT_FLD_DEF_TYPE.FDT_DATE
                service.const_FldDefTypeDateTime = response.data.const_FldDefTypeDateTime;    // ApiTypes.ADEPTT_FLD_DEF_TYPE.FDT_DT_DATETIME
                service.const_DateFormatWindows = response.data.const_DateFormatWindows;      // ApiTypes.DATE_FMT.DF_WINDOWS
                service.const_FldDefTypeLogical = response.data.const_FldDefTypeLogical;      // ApiTypes.ADEPTT_FLD_DEF_TYPE.FDT_LOGICAL

                service.dateFormat = response.data.dateFormat;
                service.dateOnlyFormatterInternal = response.data.dateOnlyFormatter;
                service.dateTimeFormatterInternal = response.data.dateTimeFormatter;

                service.uiDateFormatter = "";
                //// DATEFMTWND - Only set the date formatter if we have a admin specified format.
                //if (service.dateFormat != service.const_DateFormatWindows) {
                    service.uiDateFormatter = service.dateOnlyFormatterInternal;
                //}

                service.tabs = [];

                //build the tabs
                angular.forEach(response.data.currentDataCard.tabs, function (item, key) {
                    var tab = {};
                    tab.id = item.dataCardTabDefinition.id;
                    tab.name = item.dataCardTabDefinition.name;
                    tab.active = key == 0;

                    //extra length to allow xtoclear on smaller input boxes
                    var extraLength = 25;

                    //Factors to get the right pixel width
                    var xFactor = 12;
                    var inputFactor = 11;
                    var uniqueId = 0;
                    //set the widths to a pixel format plus padding to allow xtoclear
                    angular.forEach(item.controls, function (item, key) {
                        item.dataCardControlDefinition.x = (item.dataCardControlDefinition.x * xFactor) + extraLength
                        if (item.dataCardControlDefinition.type == service.const_FIeldTypePrompt) {
                            item.dataCardControlDefinition.y = prompt.dataCardControlDefinition.y * yFactor + yOffsetPrompts;
                        }
                        item.dataCardControlDefinition.width = (item.dataCardControlDefinition.width * inputFactor) + extraLength;
                        item.uniqueId = uniqueId;
                        uniqueId = uniqueId + 1;
                    });

                    // All of the prompts.
                    tab.prompts = $filter('filter')(item.controls, { dataCardControlDefinition: { type: service.const_FieldTypePrompt } });

                    // List of contorls that are not prompts or dates.
                    var notPromptsOrDates = $filter('filter')(item.controls, function (obj) {
                        if (obj.dataCardControlDefinition.type == service.const_FieldTypePrompt)
                            return false;
                        if (obj.schemaModel.fieldDefinition.fldDefType == service.const_FldDefTypeDateOnly)
                            return false
                        if (obj.schemaModel.fieldDefinition.fldDefType == service.const_FldDefTypeDateTime)
                            return false;
                        return true;
                    });
             
                    // All of the text boxes that are not restricted.
                    tab.textBoxes = $filter('filter')(notPromptsOrDates, { schemaModel: { fieldDefinition: { bRestricted: false } } });

                    //Schema ids for library related fields
                    var librarySchemaIds = ['SCHEMA_S_LIBNAME', 'SCHEMA_S_FOLDER', 'SCHEMA_S_LIBPATH'];

                    //filters controls not related to library
                    var noLibraryFields = $filter('filter')(tab.textBoxes, function (obj) {                   
                        if (librarySchemaIds.indexOf(obj.dataCardControlDefinition.id) != -1) {
                            return false;
                        }
                        return true;
                    });

                    
                    //filters controls related to the library
                    var libraryFields = $filter('filter')(item.controls, function (obj) {
                        if (librarySchemaIds.indexOf(obj.dataCardControlDefinition.id) != -1) {
                            return true;
                        }
                        return false;
                    })

                    tab.libraryFields = $filter('filter')(libraryFields);
                    tab.textBoxes = $filter('filter')(noLibraryFields);
                   
                    //get logical fields
                    tab.logical = $filter('filter')(tab.textBoxes, { schemaModel : { fieldDefinition: {fldDefType: service.const_FldDefTypeLogical} } });

                    //remove logical fields
                    tab.textBoxes = $filter('filter')(tab.textBoxes, { schemaModel: { fieldDefinition: { fldDefType: '!'+service.const_FldDefTypeLogical } } });

                    // All of the text boxes that are restricted.
                    tab.textBoxesRestricted = $filter('filter')(notPromptsOrDates, { schemaModel: { fieldDefinition: { bRestricted: true } } }); 

                    // All of the dates.
                    tab.dates = $filter('filter')(item.controls, function (obj) {
                        if (obj.dataCardControlDefinition.type != service.const_FieldTypePrompt) {
                            if (obj.schemaModel.fieldDefinition.fldDefType == service.const_FldDefTypeDateOnly || obj.schemaModel.fieldDefinition.fldDefType == service.const_FldDefTypeDateTime)
                                return true;
                        }
                        return false;
                    });


                    //add each unique schema id's to an array to bind textbox values to them.
                    angular.forEach(item.controls, function (item) {
                        //check for schema id, no duplicates.
                        if (item.dataCardControlDefinition.type != 80) {
                            var obj = service.schemaDefinitions[item.schemaModel.schemaDefinition.id];
                            if (!obj) {
                                service.schemaDefinitions[item.schemaModel.schemaDefinition.id] = { displayName: item.schemaModel.schemaDefinition.displayName };
                            }
                        }
                        
                    });
                    service.tabs.push(tab);
                });
                var schemas = [];
                angular.forEach(service.schemaModels, function (item, key) {
                    schemas.push(key);
                })
                var params = JSON.stringify(schemas);
                service.loading = false;
                deferred.resolve();
                            
            }, function (error) {
                service.loading = false;
                deferred.reject(error);
                console.log(error);
            });
            return deferred.promise;
        }

        // Called when the users picks a different DataCard from the dropdown.
        function setCurrent() {
            service.schemaModels = {};
            service.loading = true;
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/DataCard/CurrentDataCardId/'.concat(service.currentDataCardId),
                method: 'PUT',
                data: JSON.stringify(""),
                headers: {
                    "Content-Type": "application/json"
                }
            });
            request.then(function (response) {
                service.loading = false;
                deferred.resolve(response);
            }, function (response) {
                service.loading = false;
                deferred.reject(response);
            });
            return deferred.promise;
        }


        //Called on demand to get the values to populate the restricted fields
        function getRestrictedValues(schemaId) {
            var deferred = $q.defer();
            var request = $http.get('../Synergis.WebApi/api/DataCard/GetRestrictedFieldValues/'.concat(encodeURIComponent(schemaId)));

            request.then(function (response) {
                var items = [];
                for (var i = 0; i < response.data.length; i++) {
                    items.push({ id: i, name: response.data[i]});
                }
                deferred.resolve(items);
            });
            return deferred.promise;
        }

        

    }
})();